import { UUID } from '@plugins/common'
import _ from 'lodash'

export default class {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      tipsEnable: false,
      tip: '',
      buttonId: ''
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/buttonConditions.js